import {Component, OnInit} from "@angular/core";
import { EventService } from "../../core/services/event.service";

@Component({
    selector: 'facebook-fundraiser',
    templateUrl: './facebook-fundraiser.component.html'
})
export class FacebookFundraiserComponent implements OnInit {

    private participant: any;
    private selectedEvent: any;

    constructor(
        public eventService: EventService
    ) {
        this.eventService.onEventChange.subscribe(event => {
            this.participant = event.gql.Participant[0];
            this.selectedEvent = event;
        });
    }


    ngOnInit() {
        this.participant = this.eventService.selectedEvent.gql.Participant[0];
        this.selectedEvent = this.eventService.selectedEvent;
    }

    isCurrentUserLinkedToFacebookFundraiser() {
        if(this.participant && this.participant.fundraiser.activeFacebookFundraiserProfiles.length > 0) {
            return  true;
        }
        return false;
    }
}